import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3 position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "Adresse", -1)
const _hoisted_3 = {
  key: 0,
  class: "google-addresses"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "text-start help error-danger"
}

import { ref, onMounted } from "vue";
import UserService from "@/services/user.service";

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleAddress',
  props: {
  modelValue: {
    type: [String],
    default: "",
  },
  address: {
    type: [String],
    default: "",
  },
  v: {
    type: Object,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (event: "update:modelValue", id);
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const addressesGooglePlace = ref([])
const errorAddresse = ref(false)
const search = ref(null)

// ===> Hooks
onMounted(async () => {
  search.value = props?.address || null
});

const handleAddressGoogleSearch = async (keyword) => {
  if (!keyword || keyword.length == 0) keyword = props.address;
  if (keyword) {
    await UserService.getAddressBykeyWord(keyword).then(
      (response) => {
        if (response.data && response.data.data && response.data.data.predictions.length > 0)
          response.data.data.predictions.forEach((ele) => {
            ele["name"] = ele.description;
          });
        addressesGooglePlace.value = response.data.data;
      },
      (error) => {
        return [];
      }
    );
  }
  else { return [] }
};

const searchPlaces = async (search) => {
  if (search != "" || search != null) {
    handleAddressGoogleSearch(search);
  }
  else {
    emit("update:modelValue", {});
    addressesGooglePlace.value = []
    console.log("empty array")
  }
}

const SelectedPlace = async (place) => {
  let place_id = place.place_id;
  errorAddresse.value = false;
  search.value = place.description;
  return await UserService.getLatLongByPlaceID(place_id).then((response) => {
    let address = {
      latitude: response?.data?.data?.result?.geometry?.location?.lat,
      longitude: response?.data?.data?.result?.geometry?.location?.lng,
      address: search.value  //response?.data?.data?.result?.formatted_address
    }
    emit("update:modelValue", address);
    addressesGooglePlace.value = []
  })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      class: "form-control",
      type: "text",
      placeholder: "Adresse",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (searchPlaces(search.value))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event))
    }, null, 544), [
      [_vModelText, search.value]
    ]),
    (addressesGooglePlace.value?.predictions?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressesGooglePlace.value.predictions, (place) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", {
                onClick: ($event: any) => (SelectedPlace(place)),
                class: "search-items cursor-pointer"
              }, _toDisplayString(place.description), 9, _hoisted_4)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (errorAddresse.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " error "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, _toDisplayString(error.$message), 1))
    }), 128))
  ]))
}
}

})